import type {ReactElement} from 'react';
import React from 'react';
import {BaseDownloadDuration} from '@Components/download-panel/components/base-download-duration/base-download-duration';
import {useDownloadPanelData} from '@Components/download-panel/download-panel.context';
import {POSTER_MIN_DURATION} from '@PosterWhiteboard/poster/poster.types';
import {DOWNLOAD_GIF_MAX_DURATION} from '@Components/download-panel/components/download-gif-duration-option/download-gif-duration-option.types';
import {noop} from '@Utils/general.util';

interface DownloadGifDurationOptionProps {
  onSlideCallback?(): void;
  onSlideEndedCallback?(): void;
}
export function DownloadGifDurationOption({onSlideCallback = noop, onSlideEndedCallback = noop}: DownloadGifDurationOptionProps): ReactElement {
  const {duration, setDuration, originalDuration} = useDownloadPanelData();

  const onDurationChanged = (value: number): void => {
    setDuration(value);
  };

  const onSlide = (value: number): void => {
    onSlideCallback();
    setDuration(value);
  };

  return (
    <BaseDownloadDuration
      onSlide={onSlide}
      onSlideEndedCallback={onSlideEndedCallback}
      min={POSTER_MIN_DURATION}
      max={DOWNLOAD_GIF_MAX_DURATION}
      duration={duration}
      onDurationChanged={onDurationChanged}
      originalDuration={originalDuration}
      sliderValue={duration}
    />
  );
}
